import { ModuleConfig } from "@microchip/melody-automodule-interface/lib/src/ModuleConfig";
import { PinsData } from "@microchip/melody-automodule-interface/lib/src/pins";
import { PinsLogic } from "@microchip/melody-automodule-interface/lib/src/types";
export { getCreatorFunctions } from "../../src/CreatorFunctions";
export { getDerivedData } from "../../src/DerivedData";

export const getPinsDataFromFile = (): PinsData | undefined => {
    try {
        return require("../../src/pinsdata.json");
    } catch {
        return undefined;
    }
};

export const getPinsLogicFromFile = (): PinsLogic | undefined => {
    try {
        return require("../../src/PinsLogic.ts");
    } catch {
        return undefined;
    }
};

export const getModuleConfigFromFile = (): ModuleConfig | undefined => {
    try {
        return require("../../src/moduleConfig.json");
    } catch {
        return undefined;
    }
};
